import type {RefObject} from 'react';

import type {Nullable} from '../../utils/utility-types';

import {isDefined} from '../../utils/typecheck';

export function isHTMLDivRefObject(
  val: unknown,
): val is RefObject<Nullable<HTMLDivElement>> {
  if (isDefined(val)) {
    const ref = val as RefObject<Nullable<HTMLDivElement>>;

    return isDefined(ref.current) && ref.current instanceof HTMLDivElement;
  }

  return false;
}
